import Route from 'vue-router'
import _ from 'lodash'
import i18n from '@/providers/i18n'
import context from '@/providers/context'

export function priorityNext(previous, to, next, router) {
  // Prevent endless loops
  if (previous.name === to.name) {
    return next();
  }
  var previous_priority = previous.meta.priority || 0;
  var to_priority = router.resolve(to).route.meta.priority || 0;
  if (previous_priority > to_priority) {
    return next();
  } else {
    return next(to);
  }
}

export function priorityPush(to, router) {
  var current = router.currentRoute;
  var current_priority = current.meta.priority || 0;
  var to_priority = router.resolve(to).route.meta.priority || 0;
  if (current_priority <= to_priority) {
    router.push(to);
  }
}

export function routeName(route) {
  var title;
  if (_.has(route, 'meta.title')) {
    title = i18n.i18next.t(route.meta.title);
  } else if (_.has(route, 'meta.trans')) {
    title = i18n.i18next.t(route.meta.trans);
  }
  var contexttitle;
  if (route.name) {
    contexttitle = context.getters.getTitle(route.name);
  }
  if (contexttitle) {
    title = contexttitle;
  } else if (_.has(route, 'instances.default.title')) {
    title = route.instances.default.title;
  }
  return title;
}


// WEBPACK FOOTER //
// ./src/providers/routing.js